/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Publication_FailedInputs */

const vi_einvoice_publication_failed = /** @type {(inputs: Einvoice_Publication_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phát hành hóa đơn chưa thành công`)
};

/**

* @param {Einvoice_Publication_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_publication_failed = /** @type {((inputs?: Einvoice_Publication_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Publication_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_publication_failed(inputs)
});